import Config from 'config';
import $$api from 'models/api';
import $$auth from 'models/auth';
import { useCallback, useEffect } from 'react';

const useTokenRefresher = () => {
    const refreshToken = useCallback(async () => {
        await $$api.participants.getMeFx();

        try {
            const cognitoUser = await $$auth.currentAuthenticatedUserFx();
            const currentSession = cognitoUser.signInUserSession;
            cognitoUser.refreshSession(currentSession.refreshToken, () => {});
        } catch (e) {
            console.error('Error refreshing the token', e);
        }
    }, []);

    useEffect(() => {
        const refreshInterval = setInterval(refreshToken, Config.application.refreshTokenIntervalMin * 60 * 1000);
        return () => clearInterval(refreshInterval);
    }, [refreshToken]);

    return null;
};

export default useTokenRefresher;
